(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldAnchorTransclude', fbFieldAnchorTranscludeDirective);

    function fbFieldAnchorTranscludeDirective() {
        return {
            restrict: "EA",
            scope: {
                element:'=',
                model:'='
                //type: '@'
            },
            controller:fbFieldAnchorTranscludeDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true,
            transclude:true,
            template: '<a  ng-click="vm.click($event)" class="<%vm.getClass()%>" ><ng-transclude></ng-transclude></a>'
        };
    }

    function fbFieldAnchorTranscludeDirectiveCtrl ($scope, $element, lodash) {
        var vm = this;

        vm.click = click;
        vm.getClass = getClass;

        function getClass() {
            return lodash.get($scope, 'element.class','');
        }

        function click($event) {
            var eventData = {
                targetScope: vm.element,
                target: $element,
                event: $event,
                model: vm.model
            };

            if (lodash.has(vm.element, 'event.click') && !lodash.get(vm.pageData, 'fbData.settings.view_only', false)) {
                $scope.$emit(vm.element.event.click, eventData);
            }
        }
    }
})();